/*
 * General custom scripts
 */

/*
* Enable cookiebot
* */
// import { cookiebotLoad } from './front/components/cookiebot';
// window.addEventListener( 'load', cookiebotLoad, false );


/*
 * Page Header
 */
import { Menu } from './front/parts/header/menu';
new Menu();

/*
 * Language Switcher
 */
import { setLanguageSwitchersHeight } from './front/language-switcher';
setLanguageSwitchersHeight();

/*
 * Nav Top
 */
import { setNavTopHeight } from './front/nav-top';
setNavTopHeight();

/*
 * Footer
 */
import { footerCopyrightYear } from './front/footer_copyright';
footerCopyrightYear();

/*
 * Forms
 */
import forms from './front/components/forms';
forms.init();

/*
 * Geo Redirect
 */
import { initGeoRedirect } from './front/components/geo-redirect';
initGeoRedirect();

/*
 * Videos
 */
import { videoProtection } from './front/video-protection';
videoProtection();
